import React from 'react';

import ModuleList from '../../components/ModuleList';

const Reports = ({ ...props }) => <ModuleList {...props} type="report" />;

export default Reports;
